import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
// import Paper from "@material-ui/core/Paper";
import constants from "../../constants/User/user";
import { useUser } from "../../context/userContext";
import { useAlert } from "../../context/Feedback/alertContext";
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/material-dashboard-react/components/dialogHowToUse";
// import connect from "../../assets/img/ConnectState.png";
import "./classes.css";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CheckIcon from "@material-ui/icons/Check";
// import { TextField } from "@material-ui/core";
// const percent = "100%";
import "./userDialog.css";
import DataService from "services/DataService";
const useStyles = makeStyles(styles);

// const useStyles = makeStyles((theme) => ({
//   root: {
//     flexGrow: 1,
//   },
//   paper: {
//     height: 300,
//     width: 200,
//     backgroundColor: "#dbdbdd",
//   },
//   control: {
//     padding: theme.spacing(2),
//   },
//   dialog: {
//     backgroundColor: "#ECECEC",
//   },
//   divNumber: {
//     backgroundColor: "#434359",
//     position: "absolute",
//     borderRadius: 10,
//     ...defaultFont,
//     border: 10,
//     margin: 5,
//     padding: 5,
//   },
//   divText: {
//     display: "flex",
//     justifyContent: "flex-start",
//     marginTop: 10,
//     marginLeft: 5,
//   },
//   divTitle: {
//     display: "flex",
//     justifyContent: "center",
//     fontWeight: "bold",
//   },
//   span: {
//     color: "black",
//     // ...defaultFont,
//     // fontFamily: "Roboto",
//   },
// }));

export default function UserDialog() {
  const {
    isActiveUserDialog,
    setActiveUserDialog,
    user,
    setUser,
    language,
    credential,
  } = useUser();
  const { setAlert } = useAlert();
  const [checked, setChecked] = useState(true);
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [password, setPassword] = useState("");
  //   const [spacing] = React.useState(2);
  const classes = useStyles();

  const handleClose = () => {
    setPassword("");
    setActiveUserDialog(false);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const populateFields = () => {
    console.log(user);
    setFirstName(user.firstname);
    setLastName(user.lastname);
  };
  const updateUser = async () => {
    if (password.length !== 0) {
      try {
        let usr = {};
        usr.email = user.email;
        usr.name = user.name;
        usr.firstname = firstname ? firstname : user.firstname;
        usr.lastname = lastname ? lastname : user.lastname;
        usr.autho = password;
        const authorization = {
          headers: {
            Authorization: credential,
          },
        };
        const response = await DataService.updateUser(usr, authorization);
        setUser(response.data);

        setPassword("");
        setAlert({
          active: true,
          text: constants.alerts.succeed[language],
          color: "success",
          sevarity: "info",
          icon: CheckIcon,
        });
      } catch (e) {
        setAlert({
          active: true,
          text: constants.alerts.wrongPass[language],
          color: "info",
          sevarity: "info",
          // icon: ErrorIcon,
        });
      }
    } else {
      setAlert({
        active: true,
        text: constants.alerts.requiredPass[language],
        color: "info",
        sevarity: "info",
        // icon: ErrorIcon,
      });
    }
  };

  return (
    <div>
      <Dialog
        TransitionProps={{
          onEntered: () => {
            populateFields;
          },
        }}
        checked={checked}
        onChange={handleChange}
        open={isActiveUserDialog}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className={classes.dialog} id="alert-dialog-slide-title">
          <div className="wrapper-title">
            {constants.modal.profile[language]}
            <div className="wrapper-button-close">
              <Button onClick={handleClose}>X</Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <Grid container justifyContent="center">
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader>
                  <h4 className={classes.cardTitleWhite}>
                    {constants.user.editProfile[language]}
                  </h4>
                  <p className={classes.cardCategoryWhite}>
                    {constants.user.creation[language]} {user.dateCreation}
                  </p>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        // labelText="Username"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          placeholder: user.name,
                          disabled: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        // labelText="Email"
                        id="email-address"
                        formControlProps={{
                          fullWidth: true,
                          disabled: true,
                        }}
                        inputProps={{
                          value: user.email,
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText={constants.user.firstName[language]}
                        onChange={(e) => {
                          setFirstName(e.target.value);
                        }}
                        id="first-name"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: firstname,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText={constants.user.lastName[language]}
                        onChange={(e) => {
                          setLastName(e.target.value);
                        }}
                        id="last-name"
                        formControlProps={{
                          fullWidth: true,
                          // disabled: true,
                        }}
                        inputProps={{
                          value: lastname,
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem>
                      <span>
                        {constants.user.numberOfGrammars[language]}:{" "}
                        {user.historicalGrammar != undefined &&
                          user.historicalGrammar.length}
                      </span>
                      <br />
                      <span>
                        {constants.user.numberOfAutomatons[language]}:{" "}
                        {user.historicalMachine != undefined &&
                          user.historicalMachine.length}
                      </span>
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} lg={12} sm={12}>
                      <CustomInput
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                        labelText="Senha"
                        id="password"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "password",
                          value: password,
                          required: true,
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Button
                    color="success"
                    onClick={() => {
                      updateUser();
                    }}
                  >
                    {constants.user.attProfile[language]}
                  </Button>
                </CardFooter>
              </Card>
            </GridItem>
          </Grid>
        </DialogContent>
        <DialogActions className={classes.dialog}></DialogActions>
      </Dialog>
    </div>
  );
}
